import { render } from "./HeartBeat.vue?vue&type=template&id=27443c82&scoped=true"
const script = {}

import "./HeartBeat.vue?vue&type=style&index=0&id=27443c82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27443c82"]])

export default __exports__